import React, { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import ListLoading from '../SearchableChecklist/ListLoading';
import { FixedSizeList as List } from 'react-window';
import AdvancedChecklistItem from './AdvancedChecklistItem';
import { AutoSizer } from 'react-virtualized';
import { ProductType } from '../../../../../../components/menu/products/ItemsContainer';
export interface IAdvancedChecklistBody {
    listData: any[];
    mainLabelKey: string;
    subLabelKey?: string;
    onItemSelection: (id: string) => void;
    onSubmit?: (selectedItems: any[]) => void;
    loading?: boolean;
    loadingMessage?: string;
    hasMainItemTag?: boolean;
    disableItemTypeSelection?: ProductType;
    itemToolbar?: (id: string, getSelected: () => any[]) => JSX.Element;
    getSelected?: () => any[];
    isVirtualizeList?: boolean;
    InfoCard?: React.ReactNode;
    idKey: string;
}

function AdvancedChecklistBody(props: IAdvancedChecklistBody) {
    const { t } = useTranslation();
    const [itemsList, setItemsList] = useState(props.listData ?? []);
    useEffect(() => {
        const tempItems = props.listData?.filter((item) => !item.hidden && item.filterHidden !== true);
        setItemsList([...tempItems]);
    }, [props.listData]);

    function Row({ index, style }: any) {
        return (
            <div style={style} key={index}>
                <AdvancedChecklistItem
                    idKey={props.idKey}
                    getSelected={props.getSelected}
                    itemToolbar={props.itemToolbar}
                    subLabelKey={props.subLabelKey}
                    disableItemTypeSelection={props.disableItemTypeSelection}
                    hasMainItemTag={props.hasMainItemTag}
                    itemData={itemsList[index]}
                    mainLabelKey={props.mainLabelKey}
                    onClick={props.onItemSelection}
                />
            </div>
        );
    }

    const renderItems = () => {
        if (itemsList?.length === 0)
            return (
                <div
                    style={{
                        textAlign: 'center',
                        marginTop: '1rem',
                    }}
                >
                    {t('errors.searchableChecklist.notFound')}
                </div>
            );
        if (props.loading) {
            return props.loadingMessage || <ListLoading />;
        }
        if (props.isVirtualizeList) {
            return (
                <AutoSizer disableWidth>
                    {({ height }) => (
                        <List
                            height={height}
                            itemCount={itemsList.length}
                            itemSize={50}
                            width={'100%'}
                            style={{
                                overflow: 'auto',
                            }}
                            useIsScrolling
                            //this is selector for cypress tests
                            className={'SEARCHABLE_CHECK_LIST'}
                        >
                            {Row}
                        </List>
                    )}
                </AutoSizer>
            );
        }

        return itemsList.map((item) => (
            <div
                style={{
                    height: '50px',
                    margin: '0.6rem 0',
                }}
            >
                <AdvancedChecklistItem
                    idKey={props.idKey}
                    getSelected={props.getSelected}
                    itemToolbar={props.itemToolbar}
                    subLabelKey={props.subLabelKey}
                    disableItemTypeSelection={props.disableItemTypeSelection}
                    hasMainItemTag={props.hasMainItemTag}
                    itemData={item}
                    selected={item.selected}
                    mainLabelKey={props.mainLabelKey}
                    onClick={props.onItemSelection}
                />
            </div>
        ));
    };
    return (
        <div
            style={{
                width: '100%',
                height: '40vh',
                minWidth: '50vh',
                overflowX: 'hidden',
                paddingTop: '1rem',
                paddingBottom: props.InfoCard ? '8rem' : '',
            }}
        >
            {renderItems()}
            {props.InfoCard}
        </div>
    );
}

export default AdvancedChecklistBody;
